export const isTestEnv =
  !!window.Cypress || import.meta.env.NODE_ENV === 'test';
